import { IntlShape } from 'react-intl'
import { BaseBudget } from 'typings'
import { create, enforce, omitWhen, test } from 'vest'
import { EMAIL_REGEX } from './constants'
import { messages } from './messages'

function isValidEmail(value: string) {
  return EMAIL_REGEX.test(value.trim())
}

export function validationSuite(intl: IntlShape) {
  return create((budget: Partial<BaseBudget>) => {
    const { $t } = intl
    const { validation } = messages
    const { amount, notification } = budget

    omitWhen(amount === undefined, () => {
      test('amount', $t(validation.greaterThan, { value: 0 }), () => {
        enforce(amount).greaterThan(0)
      })
    })

    test('amount', $t(validation.required), () => {
      enforce(amount).isNotEmpty()
    })

    omitWhen(!notification?.enable, () => {
      test(
        'notification.thresholds',
        $t(validation.notificationThresholdRequired),
        () => {
          const thresholds = notification?.thresholds ?? []
          enforce(thresholds.length).greaterThan(0)
        }
      )

      test(
        'notification.emails',
        $t(validation.required),
        () => {
          const emails = notification?.emails ?? []
          enforce(emails).isNotEmpty()
        }
      )

      test(
        'notification.emails',
        $t(validation.emailInvalidMultiple),
        () => {
          const emails = notification?.emails ?? []
          const hasValidEmail = emails.every(
            (e) => e.trim().length > 0 && isValidEmail(e)
          )
          enforce(hasValidEmail).isTruthy()
        }
      )
    })
  })
}
